
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/monitor/algorithms-and-lists",
      function () {
        return require("private-next-pages/docs/monitor/algorithms-and-lists.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/monitor/algorithms-and-lists"])
      });
    }
  